import React from "react";
import {connect} from "react-redux";
import {isElectron} from "react-device-detect";
import FatalError from "./components/screens/FatalError";
import {errorApp} from "./reducers/app";
import store from "./localStorage";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error) {
        errorApp(store.dispatch, error);
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        if (isElectron) {
            try {
                const logger = require('electron-log');
                logger.error({error: error, info: info});
            } catch (e) {
                console.error(e)
            }
        } else {
            console.error(error)
        }
    }

    render() {
        if (this.state.hasError) {
            return <FatalError/>;
        }
        return this.props.children;
    }
}

const mapStateToProps = (store) => {
    return {
        app: store.appState,
    };
};

export default connect(mapStateToProps)(ErrorBoundary);